/**
 * @generated SignedSource<<5dcaf80e0e733b1ecbb53e6c92f55d5b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useRemoveFlightMutation$variables = {
  id: string;
};
export type useRemoveFlightMutation$data = {
  readonly removeFlightFromPackageDate: {
    readonly " $fragmentSpreads": FragmentRefs<"PackageDateEditTabs_packageDate" | "PackageDateSidebar_packageDate">;
  };
};
export type useRemoveFlightMutation = {
  response: useRemoveFlightMutation$data;
  variables: useRemoveFlightMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "arrivalDatetime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "departDatetime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "duration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "departAirportCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "arrivalAirportCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "supplier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "flightNumber",
        "storageKey": null
      }
    ],
    "type": "FlightSegment",
    "abstractKey": null
  },
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRemoveFlightMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PackageDate",
        "kind": "LinkedField",
        "name": "removeFlightFromPackageDate",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PackageDateEditTabs_packageDate"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PackageDateSidebar_packageDate"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRemoveFlightMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PackageDate",
        "kind": "LinkedField",
        "name": "removeFlightFromPackageDate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Package",
            "kind": "LinkedField",
            "name": "package",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Airport",
                "kind": "LinkedField",
                "name": "defaultDepartureAirport",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Airport",
                "kind": "LinkedField",
                "name": "defaultArrivalAirport",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Flight",
            "kind": "LinkedField",
            "name": "flight",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceLive",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isUpdating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlightPrice",
                        "kind": "LinkedField",
                        "name": "lastSuccessfulUpdate",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "provider",
                        "storageKey": null
                      }
                    ],
                    "type": "Flight",
                    "abstractKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "forwardSegments",
                    "plural": true,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "returnSegments",
                    "plural": true,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "FlightType",
                "abstractKey": "__isFlightType"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  },
                  {
                    "kind": "Literal",
                    "name": "onlyPriceChanged",
                    "value": true
                  }
                ],
                "concreteType": "FlightPriceConnection",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlightPriceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlightPrice",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "priceChange",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "newPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "actualPrice",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "serviceMessage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "history(first:10,onlyPriceChanged:true)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "start",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "end",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceOld",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5cbe8d336b7777181475c7c5e5999061",
    "id": null,
    "metadata": {},
    "name": "useRemoveFlightMutation",
    "operationKind": "mutation",
    "text": "mutation useRemoveFlightMutation(\n  $id: ID!\n) {\n  removeFlightFromPackageDate(id: $id) {\n    ...PackageDateEditTabs_packageDate\n    ...PackageDateSidebar_packageDate\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment FlightDetailsPrice_flight on Flight {\n  priceLive\n  isUpdating\n  lastSuccessfulUpdate {\n    createdAt\n    id\n  }\n  ...FlightListProvider_flight\n}\n\nfragment FlightDetails_flight on FlightType {\n  __isFlightType: __typename\n  ...FlightDetailsPrice_flight\n  forwardSegments {\n    __typename\n    ...FlightInfo_segments\n    id\n  }\n  returnSegments {\n    __typename\n    ...FlightInfo_segments\n    id\n  }\n}\n\nfragment FlightInfoEndpoint_segment on FlightSegment {\n  departAirportCode\n  departDatetime\n  arrivalAirportCode\n  arrivalDatetime\n}\n\nfragment FlightInfoFullSegment_segment on FlightSegment {\n  departAirportCode\n  departDatetime\n  arrivalAirportCode\n  arrivalDatetime\n}\n\nfragment FlightInfoSegmentInfo_segment on FlightSegment {\n  supplier\n  flightNumber\n  departDatetime\n  arrivalDatetime\n}\n\nfragment FlightInfo_segments on FlightSegment {\n  arrivalDatetime\n  departDatetime\n  duration\n  ...FlightInfoFullSegment_segment\n  ...FlightInfoEndpoint_segment\n  ...FlightInfoSegmentInfo_segment\n}\n\nfragment FlightListProvider_flight on Flight {\n  provider\n}\n\nfragment FlightPriceChangeIcon_entry on FlightPrice {\n  priceChange\n}\n\nfragment FlightPriceHistoryRow_entry on FlightPrice {\n  priceChange\n  newPrice\n  actualPrice\n  createdAt\n  status\n  serviceMessage\n  ...FlightPriceChangeIcon_entry\n}\n\nfragment FlightPriceHistoryTable_history on FlightPriceConnection {\n  edges {\n    node {\n      id\n      ...FlightPriceHistoryRow_entry\n    }\n  }\n  pageInfo {\n    total\n    ...Table_pageInfo\n  }\n}\n\nfragment FlightSearchForm_defaultArrivalAirport on Airport {\n  id\n  name\n  code\n}\n\nfragment FlightSearchForm_defaultDepartureAirport on Airport {\n  id\n  name\n  code\n}\n\nfragment PackageDateAddFlightDialog_package on Package {\n  defaultDepartureAirport {\n    ...FlightSearchForm_defaultDepartureAirport\n    id\n  }\n  defaultArrivalAirport {\n    ...FlightSearchForm_defaultArrivalAirport\n    id\n  }\n}\n\nfragment PackageDateAddFlightDialog_packageDate on PackageDate {\n  id\n  start\n  end\n}\n\nfragment PackageDateEditFlightPriceHistory_flight on Flight {\n  history(first: 10, onlyPriceChanged: true) {\n    ...FlightPriceHistoryTable_history\n    pageInfo {\n      total\n    }\n  }\n}\n\nfragment PackageDateEditFlight_package on Package {\n  ...PackageDateAddFlightDialog_package\n}\n\nfragment PackageDateEditFlight_packageDate on PackageDate {\n  id\n  flight {\n    ...FlightDetails_flight\n    ...PackageDateEditFlightPriceHistory_flight\n    id\n  }\n  ...PackageDateAddFlightDialog_packageDate\n}\n\nfragment PackageDateEditMain_packageDate on PackageDate {\n  id\n  start\n  end\n  price\n  priceOld\n}\n\nfragment PackageDateEditTabs_packageDate on PackageDate {\n  id\n  package {\n    ...PackageDateEditFlight_package\n    id\n  }\n  flight {\n    id\n  }\n  ...PackageDateEditMain_packageDate\n  ...PackageDateEditFlight_packageDate\n}\n\nfragment PackageDateSidebar_packageDate on PackageDate {\n  start\n  end\n  package {\n    id\n    name\n  }\n  ...EntitySidebar_entity\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n"
  }
};
})();

(node as any).hash = "33dfe2c6866a4aa8580dcf17d5a871d6";

export default node;
